<div>
  <!-- Presets -->
  <div class="flex gap-1.5 mb-2">
    <button *ngFor="let p of presets" (click)="applyPreset(p)"
      class="px-2 py-1 rounded-md text-[10px] font-semibold transition-colors"
      [ngClass]="activePreset === p ? 'bg-[var(--primary-dark)] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'">
      {{p}}
    </button>
  </div>

  <!-- Custom date inputs -->
  <div *ngIf="activePreset === 'Custom'" class="flex items-center gap-1.5">
    <ui-datepicker [value]="startDate" (valueChange)="onStartChange($event)" [compact]="true"></ui-datepicker>
    <span class="text-[9px] text-gray-400">→</span>
    <ui-datepicker [value]="endDate" (valueChange)="onEndChange($event)" [compact]="true"></ui-datepicker>
  </div>
</div>
